import React from "react";
export default ({ texts, onReturn }) => (React.createElement("div", { "data-ecom-frame": true },
    React.createElement("div", { className: "frame-body" },
        React.createElement("div", { "data-ecom-page": "justify-center", className: "text-center" },
            React.createElement("section", { className: "page-section" },
                React.createElement("div", { "data-ecom-alert": "error" },
                    React.createElement("div", { className: "alert-icon-section" },
                        React.createElement("div", { className: "alert-icon" },
                            React.createElement("i", { className: "icon-exclamation no-margin" }))),
                    React.createElement("div", { className: "alert-content" }, texts.map((text, index) => (React.createElement("p", { key: `error-item-${index}` }, text)))))),
            React.createElement("section", { className: "page-section" },
                React.createElement("button", { "data-ecom-link": true, onClick: onReturn }, "G\u00E5 tillbaka"))))));
